import { supabase } from "../supabaseClient";

export const FEATURE_AI_LEAGUE_AVERAGE_IMPORT = "ai_league_average_import";
export const FEATURE_AI_SHEET_IMPORT = "ai_sheet_import";
export const FEATURE_CHECK_PRINTING = "check_printing";

/** Org Average catalog extract (null tournament_id). Match process-league-sheet. */
export const AVERAGE_IMPORT_PLAN_MESSAGE =
  "Average import is part of AI Assist and Priority. Your first tournament includes it free. Open Plan to see options.";

const isGrantActive = (row, now = new Date()) => {
  if (!row?.enabled) return false;
  if (row.startsAt && new Date(row.startsAt) > now) return false;
  if (row.endsAt && new Date(row.endsAt) <= now) return false;
  return true;
};

const quietMissingAiFunction = (error) =>
  error?.code === "PGRST202" ||
  String(error?.message || "").includes("ai_feature_allowed");

export const listEnabledFeatureKeys = async (organizationID) => {
  if (!organizationID) return [];
  const { data, error } = await supabase
    .from("organizationFeatures")
    .select("featureKey, enabled, startsAt, endsAt")
    .eq("organizationID", organizationID)
    .eq("enabled", true);

  if (error) throw error;
  const keys = (data || [])
    .filter((row) => isGrantActive(row))
    .map((row) => row.featureKey);

  if (!keys.includes(FEATURE_AI_LEAGUE_AVERAGE_IMPORT)) {
    const trialTournament = await supabase.rpc("trial_tournament_id", {
      p_organization_id: organizationID,
    });
    const trialId = trialTournament.data || null;
    if (trialTournament.error) {
      if (!quietMissingAiFunction(trialTournament.error)) {
        console.error(trialTournament.error);
      }
    } else if (trialId) {
      const trial = await supabase.rpc("ai_feature_allowed", {
        p_organization_id: organizationID,
        p_feature_key: FEATURE_AI_LEAGUE_AVERAGE_IMPORT,
        p_tournament_id: trialId,
      });
      if (trial.error) {
        if (!quietMissingAiFunction(trial.error)) console.error(trial.error);
      } else if (trial.data) {
        keys.push(FEATURE_AI_LEAGUE_AVERAGE_IMPORT);
      }
    }
  }

  return keys;
};

export const hasFeature = async (organizationID, featureKey) => {
  if (!organizationID || !featureKey) return false;
  const { data, error } = await supabase.rpc("has_feature", {
    p_organization_id: organizationID,
    p_feature_key: featureKey,
  });
  if (error) throw error;
  return Boolean(data);
};

export const tournamentHasAiFeature = async (
  organizationID,
  featureKey,
  tournamentID
) => {
  if (!organizationID || !featureKey) return false;
  const { data, error } = await supabase.rpc("ai_feature_allowed", {
    p_organization_id: organizationID,
    p_feature_key: featureKey,
    p_tournament_id: tournamentID || null,
  });
  if (error) {
    if (!quietMissingAiFunction(error)) console.error(error);
    return hasFeature(organizationID, featureKey);
  }
  return Boolean(data);
};
